import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbDate, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
 
import { ActivatedRoute, Router } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { PostingOrderService } from '../../posting-order.service';
import { CommonService } from '../../Model/Common/common.service';
import { SessionService } from '../../Util/Session/session.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import { AllotmentDetailService } from '../../allotment-detail.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { EmployeepayslipserviceService } from '../employeepayslipservice/employeepayslipservice.service';
 
 
@Component({
  selector: 'app-employee-payslip-generation',
  standalone: true,
  imports: [LoaderComponent, CommonModule, DataTablesModule, NgSelectModule, FormsModule, NgbDatepickerModule],
  templateUrl: './employee-payslip-generation.component.html',
  styleUrl: './employee-payslip-generation.component.scss'
})
export class EmployeePayslipGenerationComponent {
 
  isDisabled: boolean = false;
  isSubContractor: boolean = false;
  user: any;
  selectAllChecked: boolean = false;
  ShowLeave: boolean = true;
  ShowOT: boolean = true;
 
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  @ViewChild('headerCheckbox') headerCheckbox: any;
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
 
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
 
  TableData = [] as any;
  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;
  dtoptions: DataTables.Settings = {};
  constructor(
    public common: CommonService,
    private session: SessionService,
    private employeepayslip: EmployeepayslipserviceService,
    private download: DownloadSampleService,
    private comboload: ComboService,
    private allotmentService: AllotmentDetailService,
    private router: Router,
    private modalService: NgbModal,
  ) {
    this.user = this.session.GetUserDetails();
    this.sitedata.UserId = this.user.UserId;
  }
 
  ngOnInit(): void {
    this.ComboLoad('Branch')
 
    this.dtoptions = {
      paging: true,
      searching: true,
      ordering: true,
      pageLength: 50,
      lengthMenu: [5, 10, 25, 50],
      destroy: true,
 
      autoWidth: false,
      responsive: true
 
    };
    this.user = this.session.GetUserDetails();
    this.sitedata.UserId = this.user;
 
  }
 
  Filter = {
    SelectType: 0,
    CompanyCode: 'PROD',
    BranchID: null as any,
    ClientID: null as any,
    SiteID: null as any,
    EmpID: 0,
    IsOnHold: 0,
    EmpType: '',
    MonthName: '',
    YearName: '',
    ToMonthName: '',
    ToYearName: '',
    TypeName: '',
    Value: '',
    GroupMonthYear: null,
    EmpCode: '',
    StatFormName: 'Employee Payslip'
  };
 
  sitedata = {
    SiteCode: '',
    UserId: ''
  };
 
  activeTab = 'payslip';
  selectedMonthYear: any;
 
 
  setTab(tab: string) {
    this.activeTab = tab;
    this.TableData = [];
 
    this.selectAllChecked = false;
 
    if (this.dtElement) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
 
        setTimeout(() => {
          this.dtTrigger.next(null);
        }, 0);
      });
    }
 
    if (tab === 'payslip') {
      this.Filter.StatFormName = 'Employee Payslip';
      this.Filter.SelectType = 3;
    } else {
      this.Filter.StatFormName = 'Employee Payslip Empwise Report';
      this.Filter.SelectType = 8;
    }
  }
 
 
  onMonthChange(event: any) {
    const value = event.target.value;
    if (value) {
      const [year, month] = value.split('-');
      const date = new Date(Number(year), Number(month) - 1);
      this.Filter.MonthName = date.toLocaleString('default', { month: 'long' }); // June
      this.Filter.YearName = year;
      this.Filter.TypeName = '';
    }
  }
 
  GetData() {
    if (!this.Filter.BranchID) {
      alert('Please select Branch');
      return;
    }
    if (this.activeTab === 'empwise') {
      if (!this.Filter.MonthName) {
        alert('Please select Month');
        return;
        this.isDisabled = true;
      }
 
      if (!this.Filter.YearName) {
        alert('Please select Year');
        return;
      }
    }
 
    this.isDisabled = true;
 
    let payload: any = {
      ...this.Filter
    };
 
    if (this.activeTab === 'payslip') {
 
      payload.StatFormName = 'Employee Payslip';
      payload.SelectType = 3;
 
    } else {
      payload.StatFormName = 'Employee Payslip Empwise Report';
      payload.SelectType = 8;
      payload.TypeName = '';
      payload.EmpType = 'FRONT';
      payload.GroupMonthYear = false;
    }
 
    // console.log('FINAL API PAYLOAD', payload);
 
    this.employeepayslip.GetEmployeeDetails(payload).subscribe({
      next: (response: any) => {
 
        this.TableData = response?.Table ? Object.values(response.Table) : [];
 
 
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.clear();
          dtInstance.destroy();
          this.isDisabled = false;
          this.dtTrigger.next(null);
        });
 
 
        this.isDisabled = false;
      },
      error: (error) => {
        console.error('API Error:', error);
        this.isDisabled = false;
      }
    });
  }
 
  PayslipPrint() {
 
    this.isDisabled = true;
    if (!this.Filter.BranchID) {
      alert('Please select Branch');
      return;
    }
 
 
    if (!this.Filter.MonthName) {
      alert('Please select Month');
      return;
    }
 
    if (!this.Filter.YearName) {
      alert('Please select Year');
      return;
    }
 
    const selectedRows = this.TableData.filter((x: any) => x.isSelected);
 
    if (selectedRows.length === 0) {
      alert('Please select at least one record');
      this.isDisabled = false;
      return;
    }
 
    const siteIds = selectedRows
      .map((x: any) => x.SiteID || x.SiteMasterID)
      .join(',');
 
    const empIds = selectedRows
      .map((x: any) => x.EmpMasterId)
      .filter((id: any) => id)
      .join(',');
 
    const monthName = this.Filter.MonthName;
    const yearName = this.Filter.YearName;
 
    let salaryMonth = '';
 
    if (monthName && yearName) {
 
      const monthIndex = new Date(`${monthName} 1, ${yearName}`).getMonth() + 1;
 
      const month = monthIndex.toString().padStart(2, '0');
 
      salaryMonth = `${yearName}-${month}-01T00:00:00`;
    }
 
    const statFormNameForPrint = this.Filter.StatFormName;
 
    const operationType =
      statFormNameForPrint === 'Employee Payslip Empwise Report' ? 2 : 1
 
    const payload = {
      UserId: "1",
      UserName: null,
      EmpType: null,
      EmpCode: null,
      StatFormName: statFormNameForPrint,
      OperationType: operationType,
      SiteMasterIDs: siteIds,
      EmpMasterIDs: empIds,
      SalaryMonth: salaryMonth,
      BranchId: String(this.Filter.BranchID),
      CustomerId: this.Filter.ClientID || 0,
      ShowLeaveDetails: this.ShowLeave,
      ShowOTDetails: this.ShowOT,
      IsCompliance: true,
      IsNonCompliance: false,
      GLT2Flag: false,
      IsNewHeader: true,
      UseSumitReport: false,
      ShowOT: this.ShowOT,
      PageSize: 'A4',
      MonthName: monthName,
      YearName: yearName,
      CompanyCode: this.user.CompanyCode
    };
 
    //console.log("FINAL PRINT PAYLOAD", payload);
 
    this.employeepayslip.PrintPayslip(payload).subscribe({
      next: (response: any) => {
        if (response?.FileName == 'No File Found') {
          alert("No Data Found");
          return;
        }
        if (response?.FileName) {
          window.open(response.FileName, '_blank');
        } else {
          alert('No File Found');
        }
      },
      error: (error) => {
        console.error('Print Error:', error);
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      }
    });
  }
 
  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype == 'Site') {
      this.Filter.SiteID = null;
      this.Sites = [];
    } else if (Combotype == 'Client') {
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
      this.Clients = [];
      this.Sites = [];
    }
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'UserType': 'A',
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID,
      'SiteId': this.Filter.SiteID,
      'EmpType': 'front',
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad) {
          if (Combotype == 'Branch') {
            this.Branchs = response.ComboLoad;
          } else if (Combotype == 'Client') {
            this.Clients = response.ComboLoad;
          } else if (Combotype == 'Site') {
            this.Sites = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
 
  selectAll(event: any) {
    const isChecked = event.target.checked;
 
    this.selectAllChecked = false;
    if (this.activeTab === 'empwise') {
 
      this.TableData.forEach((item: any) => {
        item.isSelected = isChecked;
      });
    }
 
    else {
      const siteMap = new Map();
      this.TableData.forEach((item: any) => {
        const siteId = item.SiteMasterID || item.SiteID;
        if (!siteMap.has(siteId)) {
          siteMap.set(siteId, isChecked);
        }
 
        item.isSelected = siteMap.get(siteId);
      });
    }
  }
 
 
  onNavigate(event: any) {
    const selected = event.next;
    const date = new Date(selected.year, selected.month - 1, 1);
    this.Filter.MonthName = date.toLocaleString('default', { month: 'long' });
    this.Filter.YearName = selected.year;
  }
 
 
  exit() {
    this.router.navigate(['/reports/frontreport/']);
  }
 
  GetSiteData() {
 
    if (!this.sitedata.SiteCode) {
      alert('Please enter Site Code');
      return;
    }
 
    this.isDisabled = true;
 
    let payload: any = {
      ...this.sitedata
    };
 
    this.employeepayslip.GetSiteCode(payload).subscribe({
      next: (response: any) => {
        const data = response?.Table || [];
 
        const errorData = response?.Table1 || [];
 
        if (errorData.length > 0 && errorData[0].ErrorCode) {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
 
          modalRef.componentInstance.Message = errorData[0].ErrorMessage;
          modalRef.result.then((result: any) => { });
 
          this.isDisabled = false;
          return;
        }
 
        if (data.length > 0) {
          const row = data[0];
 
          this.Filter.BranchID = row.BranchID;
          this.Filter.ClientID = row.ClientID;
          this.Filter.SiteID = row.SiteId;
 
          this.Branchs = [{
            BranchMasterID: row.BranchID,
            BranchName: row.BranchName
          }];
 
          this.Clients = [{
            ClientGroupMasterID: row.ClientID,
            ClientGroupName: row.ClientName
          }];
 
          this.Sites = [{
            SiteMasterID: row.SiteId,
            SiteName: row.SiteName
          }];
 
          setTimeout(() => {
            this.GetData();
          }, 100);
        }
 
        this.isDisabled = false;
      },
 
      error: (error) => {
        console.error('API Error:', error);
        this.isDisabled = false;
      }
    });
  }
 
}